import { IMobizStateService, PagedResults } from '../@posturinn/common-react/core';
import {
	INotificationsQueryParameters,
	INotificationsService,
	IRecentNotificationsService,
	Notification,
	NOTIFICATIONS_SERVICE,
	RECENT_NOTIFICATIONS_SERVICE,
} from '../@posturinn/common-react/notifications';
import {
	FETCH_NEW_NOTIFICATIONS_FAILED,
	FETCH_NEW_NOTIFICATIONS_FULFILLED,
	FETCH_NOTIFICATIONS,
	FETCH_NOTIFICATIONS_FAILED,
	FETCH_NOTIFICATIONS_FULFILLED,
	FETCH_RECENTLY_VIEWED_DATE_FAILED,
	SET_RECENTLY_VIEWED_DATE_FAILED,
	SET_RECENTLY_VIEWED_DATE_FULFILLED,
} from '../constants/actions/notificationsActions';

export const getAllNotifcations = (page: number) => {
	return async function (dispatch, getState) {
		dispatch({ type: FETCH_NOTIFICATIONS, payload: null });
		const { injector } = getState().mobizReducer;
		const notificationsService: INotificationsService = injector.get(NOTIFICATIONS_SERVICE);
		const stateService: IMobizStateService = injector.get(IMobizStateService);
		const query: INotificationsQueryParameters = {
			organizationId: stateService.currentMembership?.value?.organizationId,
			page: page,
			pageSize: 3,
		};
		notificationsService.getNotifications(query).subscribe({
			next: (pagedNotifications: PagedResults<Notification>) => {
				dispatch({ type: FETCH_NOTIFICATIONS_FULFILLED, payload: pagedNotifications });
			},
			error: error => {
				dispatch({ type: FETCH_NOTIFICATIONS_FAILED });
				console.log(error);
			},
		});
	};
};

export const setAllNotificationsRead = () => {
	return async function (dispatch, getState) {
		dispatch({ type: FETCH_NOTIFICATIONS, payload: null });
		const { injector } = getState().mobizReducer;
		const recentNotificationsService: IRecentNotificationsService = injector.get(RECENT_NOTIFICATIONS_SERVICE);

		recentNotificationsService.setMostRecentlyViewedNotificationDate(new Date()).subscribe({
			next: () => {
				dispatch({ type: SET_RECENTLY_VIEWED_DATE_FULFILLED });
			},
			error: error => {
				dispatch({ type: SET_RECENTLY_VIEWED_DATE_FAILED });
				console.log(error);
			},
		});
	};
};

export const getNewNotifications = () => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const recentNotificationsService: IRecentNotificationsService = injector.get(RECENT_NOTIFICATIONS_SERVICE);

		recentNotificationsService.getMostRecentlyViewedNotificationDate().subscribe({
			next: (date: Date) => {
				const notificationsService: INotificationsService = injector.get(NOTIFICATIONS_SERVICE);
				const stateService: IMobizStateService = injector.get(IMobizStateService);
				const query: INotificationsQueryParameters = {
					organizationId: stateService.currentMembership?.value?.organizationId,
					fromDate: date,
				};
				notificationsService.getNotifications(query).subscribe({
					next: (newNotifications: PagedResults<Notification>) => {
						dispatch({ type: FETCH_NEW_NOTIFICATIONS_FULFILLED, payload: newNotifications.totalCount });
					},
					error: error => {
						dispatch({ type: FETCH_NEW_NOTIFICATIONS_FAILED });
						console.log(error);
					},
				});
			},
			error: error => {
				dispatch({ type: FETCH_RECENTLY_VIEWED_DATE_FAILED });
				console.log(error);
			},
		});
	};
};

export const clearMostRecentlyViewedNotificationDates = () => {
	return async function (getState) {
		const { injector } = getState().mobizReducer;
		const recentNotificationsService: IRecentNotificationsService = injector.get(RECENT_NOTIFICATIONS_SERVICE);
		recentNotificationsService.clearMostRecentlyViewedNotificationDates().subscribe({
			next: () => {
				console.log('date cleared');
			},
		});
	};
};
